import { inputValidationDirective } from './input-validation.directive';

export const inputValidation = angular
	.module('common.libs.inputvalidation', [])
	.directive('inputValidation', inputValidationDirective)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/input-validation/input-validation.module.js